import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'preround-ko-overview',
  templateUrl: 'preround-ko-overview.html',
})
export class PreroundKoOverviewPage {
  gamePlanList: IGamePlan[] = [];
  
  @Input() plan: any;
  @Input() header: boolean = true;

  @Output() onEdit = new EventEmitter<any>();

  margin: boolean = false;

  constructor(private navCtrl: NavController){
    console.log(navCtrl.getViews());
    // this.margin = navCtrl.getViews().length > 1 ? true: false;
  }

  onOpenEdit(r: number, i: number, j: number){
    this.onEdit.emit({ r: r, i: i, j: j, graph: false});
  }

  onRemoveTeam(){ }

  sort(){
    if(!this.plan) return [];

    return this.plan.teams.sort((a, b) => b.points - a.points);
  }

  getGroupName(i: number){
    let ASCII = 65;
    return String.fromCharCode(ASCII + i);
  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-pre-round-ko/overview/preround-ko-overview.ts